// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Backspace: React.FC = () => {
    return <svg width="18px" height="14px" viewBox="0 0 18 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="VD-Set-1" stroke="none" strokeWidth="1" fill="currentColor" fillRule="evenodd">
        <path d="M16.5,0.25 L5.25,0.25 C4.7325,0.25 4.3275,0.5125 4.0575,0.91 L0,7 L4.0575,13.0825 C4.3275,13.48 4.7325,13.75 5.25,13.75 L16.5,13.75 C17.325,13.75 18,13.075 18,12.25 L18,1.75 C18,0.925 17.325,0.25 16.5,0.25 L16.5,0.25 Z M14.25,9.6925 L13.1925,10.75 L10.5,8.0575 L7.8075,10.75 L6.75,9.6925 L9.4425,7 L6.75,4.3075 L7.8075,3.25 L10.5,5.9425 L13.1925,3.25 L14.25,4.3075 L11.5575,7 L14.25,9.6925 L14.25,9.6925 Z" id="icon-backspace" fill="#75757A"></path>
    </g>
</svg>;
};

export default React.memo(Backspace);
